module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/plan_type_resort-af401ee43cb1e8ee37b2d2cd179e46ec.webp";